import 'regenerator-runtime/runtime';
import { SagaIterator } from 'redux-saga';
import { call, cancel, select, takeEvery } from 'redux-saga/effects';
import {
  GlobalAction,
  GlobalActions,
  GlobalPut,
  WrappedSavedStates,
  WrappedSavedStatesLoaded,
} from '@ps20-frontend/shop-integration-redux';
import { App } from '@ps20-frontend/frontend-models';
import { safeSaga } from '@ps20-frontend/safe-saga';
import { IAppState } from '../appState';
import { productLoadingActions } from './productRelevantDataChangedSaga';

export function* watchFetchTierrassenOnLoad(): SagaIterator {
  yield takeEvery(
    GlobalActions.SAVED_STATES_LOADED,
    safeSaga(fetchTierrassenOnLoadSaga, App.TKV_V2),
  );
}

/**
 * The offers of a saved Tiergruppe that were saved with their own state. The catalogs are
 * broadcast to all stores, so one of them asks for the whole group.
 */
const savedGroupOffers = (savedStates: WrappedSavedStates): string[] => {
  const tgv = savedStates.find(saved => saved.appId === App.TGV);
  const angebotsIds = (tgv?.state as { tiergruppe?: { angebotsIds?: Record<string, string> } })
    ?.tiergruppe?.angebotsIds;
  return Object.values(angebotsIds ?? {}).filter(angebotsId =>
    savedStates.some(saved => saved.appId === App.TKV_V2 && saved.angebotsId === angebotsId),
  );
};

export function* fetchTierrassenOnLoadSaga(
  action: GlobalAction<WrappedSavedStatesLoaded>,
): SagaIterator {
  const savedStates = action.payload.savedStatesLoaded;
  const state: IAppState = yield select();

  const loadedAppState = savedStates?.find(
    s => s.appId === App.TKV_V2 && s.angebotsId === state.angebotsId,
  );

  if (!loadedAppState) {
    return yield cancel();
  }

  const groupOffers = savedGroupOffers(savedStates);
  const isGroupOffer = groupOffers.includes(state.angebotsId);
  if (isGroupOffer && groupOffers[0] !== state.angebotsId) {
    return yield cancel();
  }

  const animalType = state.versicherungsnehmer?.animalType;
  if (!animalType) {
    return yield cancel();
  }

  const globalPut = GlobalPut.getInstance();
  yield call(
    globalPut.put.bind(globalPut),
    productLoadingActions(
      state,
      animalType,
      state.vertragsoptionen?.coverageType,
      true,
      isGroupOffer,
    ),
  );
}
